export default __webpack_public_path__ + "static/media/StorySaoJoao.94ad611e.png";